import { createContext } from 'react';

import type { PageProps } from './Page.types';

export type PageContext = {
  notifications: PageProps['notifications'];
};

export const PageContext = createContext<PageContext>({} as PageContext);
